import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import logo from '../assets/logo_oficina.png';
import { FaWhatsapp, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: #4F4C4C;
  padding: 4rem 0 2rem 0;
  color: #f9f9f9;
`;

const FooterWrap = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  width: 100%;
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterLogo = styled(Link)`
  cursor: pointer;
  margin-bottom: 1rem;
  img {
    height: 60px;
  }
`;

const FooterText = styled.p`
  margin-bottom: 1rem;
  max-width: 250px;
`;

const FooterLinkTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  color: #ffffff;
`;

const FooterLink = styled(Link)`
  color: #f9f9f9;
  margin-bottom: 0.75rem;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    color: #c77408;
    transition: 0.3s ease-out;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  font-size: 1rem;
  
  svg {
    color: #c77408;
    margin-right: 10px;
    margin-top: 4px;
  }
`;

const ContactLink = styled.a`
  color: #f9f9f9;
  text-decoration: none;
  
  &:hover {
    color: #c77408;
    transition: 0.3s ease-out;
  }
`;

const BottomBar = styled.div`
  width: 100%;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #7a7a7a;
  text-align: center;
`;

const WebsiteRights = styled.small`
  color: #f9f9f9;
`;


const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrap>
        <FooterGrid>
          <FooterColumn>
            <FooterLogo to="hero" smooth={true} duration={500}>
              <img src={logo} alt="Primeira Linha logo" />
            </FooterLogo>
            <FooterText>
              Mais de 10 anos de experiência em reparação veicular com a confiança que você merece.
            </FooterText>
          </FooterColumn>

          <FooterColumn>
            <FooterLinkTitle>Navegação</FooterLinkTitle>
            <FooterLink to="about" smooth={true} duration={500}>Sobre</FooterLink>
            <FooterLink to="services" smooth={true} duration={500}>Serviços</FooterLink>
            <FooterLink to="location" smooth={true} duration={500}>Localização</FooterLink>
            <FooterLink to="towtruck" smooth={true} duration={500}>Guincho 24h</FooterLink>
          </FooterColumn>

          <FooterColumn>
            <FooterLinkTitle>Fale Conosco</FooterLinkTitle>
            <ContactItem>
              <FaMapMarkerAlt />
              <span>Av. Santos, 181 - Jd. Novo Mundo, Goiânia - GO</span>
            </ContactItem>
            <ContactItem>
              <FaPhone />
              <ContactLink href="tel:556232843050">(62) 3284-3050</ContactLink>
            </ContactItem>
            <ContactItem>
              <FaWhatsapp />
              <ContactLink href="https://api.whatsapp.com/send?phone=556232843050" target="_blank" rel="noopener noreferrer">
                (62) 3284-3050 (WhatsApp)
              </ContactLink>
            </ContactItem>
          </FooterColumn>
        </FooterGrid>

        <BottomBar>
          <WebsiteRights>
            Primeira Linha Reparação Veicular © {new Date().getFullYear()} Todos os direitos reservados.
          </WebsiteRights>
        </BottomBar>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;